import { ContainerModule } from 'inversify';
import * as Store from './store';
import * as Service from './service';
import { BadgeStoreModuleSymbol } from './store';
import { PlayerModuleSymbol } from '../api';
import { BadgePlayerModule } from './badge-player-module';

const badgeModule = new ContainerModule((bind) => {
  // store
  bind(Store.BadgeStoreModuleSymbol).toConstantValue(Store.badgeStoreModule);
  bind(Store.BadgesQuerySymbol).toDynamicValue((c) => c.container.get(BadgeStoreModuleSymbol));
  
  // player module
  bind(PlayerModuleSymbol).to(BadgePlayerModule)
});

export const badgeModules = [
  badgeModule,
  Service.badgeServiceModule
]
